/**
 * GA4 — flujo DELFU (www.delfuocampo.com).
 * Measurement ID: G-QDGH3RF9KY (build-time VITE_GA_TRACKING_ID en Railway).
 */

export const GA_MEASUREMENT_ID =
  (import.meta.env.VITE_GA_TRACKING_ID as string | undefined)?.trim() ||
  "G-QDGH3RF9KY";

export const GA_FLOW_NAME = "DELFU";

export const GA_STREAM_URL = "https://www.delfuocampo.com";

/** ID del flujo de datos web en GA4 Admin (informativo; no va en gtag). */
export const GA_STREAM_ID = "14380271499";

/** ID de la cuenta GA4 (Admin → configuración de la cuenta). */
export const GA_ACCOUNT_ID = "391557875";

/** ID de la propiedad GA4 (Admin → Detalles de la propiedad). */
export const GA_PROPERTY_ID = "533246253";